import { useState } from "react";
import { Typography, Modal, Button } from "antd";
import "./project-objects.scss";
import { useObjects } from "@entities/object";
import { useCoordinator } from "@shared/lib/hooks";
import { ObjectCard } from "../object-card";
import { ObjectCardSkeleton } from "../object-card-skeleton";

const { Title, Text } = Typography;
export const ProjectObjects = () => {
  const [, setIsForm] = useState(false);
  const { projectId } = useCoordinator() as {
    projectId: string;
  };

  const { data, isLoading } = useObjects({
    projectId,
  });
  const [, setObjectIdEdit] = useState<null | string>(null);

  const handleIsForm = (event: any, status: boolean, objectId?: string) => {
    event.stopPropagation();
    setObjectIdEdit(objectId || "");
    setIsForm(status);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="project-objects-header">
        <Title level={3} className="project-objects-title project-members-title">
          Список обьектов строительства
        </Title>
        {/* <Button>Добавить обьект</Button> */}
      </div>
      <div className="project-object-cards-container">
        {isLoading && !data && <ObjectCardSkeleton />}
        {!isLoading &&
          data &&
          data?.buildingObjects?.length > 0 &&
          data.buildingObjects.map((object) => (
            <ObjectCard
              key={object.buildingObjectId}
              handleIsForm={handleIsForm}
              projectId={projectId}
              object={object}
            />
          ))}
        {!isLoading && (!data || data?.buildingObjects?.length === 0) && (
          <p className="project-objects-empty">Объекты не созданы</p>
        )}
      </div>
      <Modal
        title="Удалить?"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        centered
        width={400}
      >
        <div>
          <Text>Вы действительно хотите удалить?</Text>
          <div className="project-objects-modal-divider" />
          <div className="project-objects-modal-actions">
            <Button type="primary" onClick={handleOk}>
              Да
            </Button>
            <Button onClick={handleCancel}>Нет</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
